import { useNavigate } from "react-router-dom"
import { Button } from "../../generic/Core"
import useTranslation from "../../../hooks/useTranslation"
import { WidgetTitle } from "../widgetTypography"


const TextWidget = ({ type, data, labels }) => {
    const navigate = useNavigate()
    const {t} = useTranslation()
    return (
        <>
            <WidgetTitle>{t(labels.title)}</WidgetTitle>
            <p>{t(labels.text)}</p>
            { labels.button ? <Button $shadow={true} $variant='secondary' onClick={(e) => { navigate(data.path) }}>{t(labels.button)}</Button>: <></>}

        </>
    )
}

export default TextWidget
